import { handleActions, combineActions } from 'redux-actions'
import * as rawActions from '../actions'

const defaultState = false

export default handleActions(
  {
    [rawActions.reset](state, action) {
      return defaultState
    },
    [rawActions.createPolicyRequest](state, action) {
      return true
    },
    [combineActions(rawActions.createPolicyFailed, rawActions.createPolicySuccess)](state, action) {
      return defaultState
    },
  },
  defaultState
)
